export default __webpack_public_path__ + "static/media/Candidate_Template_ARS_v1.02c685d3.xlsx";